<template>
  <v-autocomplete
    v-model="selectedCountries"
    :items="countries"
    label="Countries"
    multiple
    chips
    clearable
    append-icon="mdi-chevron-down"
    @change="updateValue"
  >
  </v-autocomplete>
</template>

<script>
import countryList from "country-list"
export default {
  data() {
    return {
      selectedCountries: []
    }
  },
  computed: {
    countries() {
      return countryList.getNames()
    }
  },
  methods: {
    updateValue() {
      this.$emit("input", this.selectedCountries)
    }
  }
}
</script>
